import React from "react"
import PropTypes from "prop-types"
import {
  rendezVousRecapContainer,
  rendezVousTitle,
  rendezVousPart6Text,
} from "./rendez-vous-part-6.module.scss"
import {
  RendezVousSubContainer,
  RendezVousTitle,
} from "../rendez-vous-styled.js"
import { StepIndicator } from "../StepIndicator/step-indicator"
import moment from "moment"
import "moment/locale/fr"

export const RendezVousPart6 = ({
  step,
  typesRendezVousData,
  typeChoisi,
  nombrePersonne,
  creneauChoisi,
  contactInfo,
}) => {
  return (
    <RendezVousSubContainer className={rendezVousRecapContainer}>
      <StepIndicator step={step} />
      <RendezVousTitle className={rendezVousTitle}>
        Récapitulatif et validation
      </RendezVousTitle>
      <p className={rendezVousPart6Text}>
        Objet de la prise de rendez-vous :{" "}
        <b>{typesRendezVousData[typeChoisi].libelle[0].value}</b>
      </p>
      <p className={rendezVousPart6Text}>
        Nombre de personnes concernées par la demande : <b>{nombrePersonne}</b>
      </p>
      <p className={rendezVousPart6Text}>Informations de contact :</p>
      <p>
        <b>
          <div>
            {contactInfo.prenom} {contactInfo.nom}
          </div>
          <div>{contactInfo.phone}</div>
          {contactInfo.mail && <div>{contactInfo.mail}</div>}
        </b>
      </p>
      <p className={rendezVousPart6Text}>
        Créneau :{" "}
        <b>{moment(creneauChoisi).format("dddd Do MMMM YYYY à LT")}</b>
      </p>
      <p className={rendezVousPart6Text}>
        Informations complémentaires pour votre rendez-vous :
      </p>
      {typesRendezVousData[typeChoisi] && (
        <div
          dangerouslySetInnerHTML={{
            __html:
              typesRendezVousData[typeChoisi].texte_commentaire[0].processed,
          }}
        />
      )}
      <p className={rendezVousPart6Text}>
        Informations relatives au règlement général sur la protection des
        données :
      </p>
      {typesRendezVousData[typeChoisi] && (
        <div
          dangerouslySetInnerHTML={{
            __html: typesRendezVousData[typeChoisi].texte_rgpd[0].processed,
          }}
        />
      )}
    </RendezVousSubContainer>
  )
}

RendezVousPart6.propTypes = {
  step: PropTypes.number,
  typesRendezVousData: PropTypes.object,
  typeChoisi: PropTypes.string,
  nombrePersonne: PropTypes.number,
  creneauChoisi: PropTypes.string,
  contactInfo: PropTypes.object,
}
